<template>
  <div
    class="h-14 bg-casal w-full font-light text-[white] grid grid-cols-2 justify-between px-4 gap-4"
  >
    <Dialog
      v-model:visible="partsDataInfoVisible"
      modal
      :header="$t('Job parts informations')"
      :style="{ width: '25rem' }"
    >
      <DataTable :loading :value="jobPartsData?.parts" paginator :rows="5">
        <Column field="part" :header="$t('Part number')">
          <template #body="{ data }">{{ data.partName ?? data?.partNumber }}</template>
        </Column>
        <Column field="cycleTimeOp" :header="$t('Cycle time OP')">
          <template #body="{ data }">{{ data.cycleTimeOp }}</template>
        </Column>
      </DataTable>
    </Dialog>
    <div class="flex flex-col">
      <div
        v-if="![0, 3, undefined].includes(audit?.currentStepIndex) && !isSpecialAudit"
        class="flex w-full justify-end"
      >
        <div class="flex flex-col w-max shrink-0 basis-auto">
          <span> {{ $t('Auditee') }}: </span>
          <span>{{ $t('WI') }}:</span>
        </div>
        <div class="flex-1 min-w-0 flex flex-col overflow-hidden">
          <span class="font-semibold ml-2 flex flex-row truncate">
            <span class="truncate w-full block">{{ auditee }}</span>
          </span>
          <Button
            unstyled
            class="font-semibold ml-2 truncate w-max cursor-pointer block underline"
            @click="showJobPartsData"
          >
            {{ wi }} <i class="far fa-stopwatch" />
          </Button>
        </div>
      </div>
    </div>
    <div class="flex flex-col w-full order-2">
      <div class="flex justify-end w-full">
        <div class="border-b">
          {{ $t('Logged') }}:
          <span class="font-semibold ml-2 truncate">
            {{ auth.user?.profile?.name }}
          </span>
        </div>
      </div>
      <div class="flex justify-end gap-4">
        <Button class="py-0" icon="fal fa-sync-alt" @click="resetForm" />
        <Button
          :label="$t('Logout')"
          icon-pos="right"
          :pt="{ label: { class: 'font-light' } }"
          class="hover:bg-transparent text-[white] w-max py-0"
          icon="fal fa-sign-out-alt"
          @click="logout()"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
const {
  $auth: { auth, logout: logoutFn },
  callHook,
} = useNuxtApp()

const audit = useState('audit') as any

const auditee = computed(() => audit.value?.steps?.settings?.auditee?.qualifier)
const wi = computed(() => audit.value?.steps?.settings?.job?.code)

const isSpecialAudit = computed(() =>
  SPECIAL_AUDITS.includes(audit.value?.steps?.settings?.audit?.type?.value || '')
)

const logout = () => {
  localStorage.clear()
  logoutFn()
}

const partsDataInfoVisible = shallowRef(false)

const jobId = computed(() => audit.value?.steps?.settings?.job?.id)
const enabled = computed(() => !!jobId.value)

const {
  data: jobPartsData,
  isFetching,
  isPending,
} = useQuery(jobsPartsQuery({ jobId: jobId, enabled }))
const loading = computed(() => isFetching.value || isPending.value)

const showJobPartsData = () => {
  partsDataInfoVisible.value = true
}

const confirm = useConfirm()
const { t } = useI18n()
const resetForm = (event: MouseEvent) => {
  const target = event.currentTarget as HTMLElement
  if (target) {
    confirm.require({
      target,
      message: `${t('Are you sure you want to reset the form?')} ${t('If you reset the form, you will lose all your previous answers and audit settings.')}`,
      accept: () => {
        callHook('app:reset:form', true)
      },
      group: 'confirm',
    })
  }
}
</script>
